const secrets = {
    third_party_token_set: {
        token_not_found: 'Registro de token não encontrado.',
        access_token_expired: 'O token de acesso expirou. Por favor, reconecte a sua conta.',
    },
};
export default Object.freeze(secrets);
